import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword as resetPasswordApiCall } from "../api";
import Password from "../components/Password";
import { useAppContext } from "../context/AppContext";
import { TextField, Button } from "@newulife/common";

export default function Reset() {
  const {
    state: {
      dictionary: { reset: contentfulData },
    },
    actions: { setMessage },
  } = useAppContext();

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const { passwordResetKey, repDID, customerDID } = params;
  let navigate = useNavigate();

  // Check if passwordResetKey exists, redirect if not
  useEffect(() => {
    if (!passwordResetKey) {
      navigate("/login");
    }
  }, [passwordResetKey, navigate]);

  const [password1, set_password1] = useState("");
  const [password2, set_password2] = useState("");
  const [password1IsValid, set_password1IsValid] = useState(false);
  const [password2IsValid, set_password2IsValid] = useState(false);
  const [formIsValid, set_formIsValid] = useState(false);
  const [
    text_resetPassword,
    text_pleaseFillOutForm,
    text_successMessage,
    text_failureMessage,
    text_guidTimedOutMessage,
    text_confirmPassword,
    text_passwordsDoNotMatch
  ] = contentfulData;

  useEffect(() => {
    if (password1 === password2) set_password2IsValid(true);
    else set_password2IsValid(false);
  }, [password1, password2]);

  useEffect(() => {
    if (password1IsValid && password2IsValid) set_formIsValid(true);
    else set_formIsValid(false);
  }, [password1IsValid, password2IsValid]);

  function valueUpdate(newValue) {
    set_password1(newValue);
  }
  function handleConfirmPasswordChange(e) {
    const { value } = e.target;
    set_password2(value);
  }
  function resetPassword() {
    resetPasswordApiCall(repDID, customerDID, passwordResetKey, password1)
      .then((response) => {
        // Check if the response contains an error
        if (response?.error || response?.IsSuccessful === false) {
          // Use the actual error message from the API response
          if (response?.error) {
            setMessage({ text: response?.message, type: "error" });
          } else {
            setMessage({ text: response?.Message, type: "error" });
          }
        } else {
          setMessage({ text: text_successMessage, type: "success" });
        }
      })
      .catch((error) => {
        // Fallback error handling
        setMessage({ text: text_failureMessage, type: "error" });
      })
      .finally(() => navigate("/login"));
  }

  return (
    <section>
      <h1 className="text-center mb-40">{text_resetPassword}</h1>
      <div className="form-max flex-20 column">
        <p>{text_pleaseFillOutForm}</p>

        <Password
          isValid={set_password1IsValid}
          onChange={valueUpdate}
          value={password1}
        />

        <ConfirmPassword onChange={handleConfirmPasswordChange} text_confirmPassword={text_confirmPassword} text_passwordsDoNotMatch={text_passwordsDoNotMatch} passwordsMatch={password2IsValid} />

        <div className="flex-20 mt-40 justify-center">
          <Button disabled={!formIsValid} type="button" onClick={resetPassword}>
            {text_resetPassword}
          </Button>
        </div>
      </div>
    </section>
  );
}
function ConfirmPassword(props) {
  const {
    state: {
      dictionary: { password: contentfulData },
    },
  } = useAppContext();

  const { onChange } = props;
  const [hidden] = useState(true);
  const text_show = contentfulData[1];
  const text_hide = contentfulData[2];
  const [hasInteracted, setHasInteracted] = useState(false);
  const [confirmValue, setConfirmValue] = useState("");
  const { text_confirmPassword, text_passwordsDoNotMatch, passwordsMatch } = props;

  const handleChange = (e) => {
    const { value } = e.target;
    setConfirmValue(value);
    onChange(e);
  };

  return (
    <div className="password-wrapper">
        <TextField
          id="password"
          name="password"
          label={text_confirmPassword}
          isErrored={!passwordsMatch && hasInteracted && confirmValue.length > 0}
          errorText={!passwordsMatch && hasInteracted && confirmValue.length > 0 ? text_passwordsDoNotMatch : ""}
          showText={text_show}
          hideText={text_hide}
          type={hidden ? "password" : "text"}
          onChange={handleChange}
          onFocus={() => setHasInteracted(true)}
          variant="filled"
        />
    </div>
  );
}
